import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App';

import VuePhotoSwipe from './plugins/PhotoSwipe';
Vue.use(VuePhotoSwipe);

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

import lineClamp from 'vue-line-clamp';
Vue.use(lineClamp);

import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
    color: '#084375',
    failedColor: '#fac428',
    // thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 100
    },
    position: 'absolute'
});

// import Sticky from 'vue-sticky-directive'
// Vue.use(Sticky)

import Quill from 'quill';
import VueQuillEditor from 'vue-quill-editor';
// import './plugins/quill-html-placeholder'

Vue.use(VueQuillEditor, {
    theme: 'bubble',
    placeholder: '',
    modules: {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            // [{ 'color': [] }, { 'background': [] }],
            // [{ 'font': [] }],
            [{ align: [] }],
            ['link'],
            ['clean']
        ]
    }
});

import TreeMenu from '@/components/TreeMenu';
Vue.component('TreeMenu', TreeMenu);

import StarRating from 'vue-star-rating';
Vue.component('StarRating', StarRating);

import { apolloProvider } from './store/apollo';

import '@/init';
import '@/validation';
import '@/router/middleware';

import '@/lodash.js';

Vue.config.productionTip = false;

// Vue.config.devtools = true

new Vue({
    router,
    store,
    apolloProvider,
    render: h => h(App)
}).$mount('#app');
